module.exports = {"TXTWCL_Suggested_amounts":{"id":"TXTWCL_Suggested_amounts","defaultMessage":"Föreslaget belopp","track":"Suggested amounts"}}